// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic-map-popover[data-v-d0497c5a]{width:100%;font-size:.75rem;overflow:hidden}address[data-v-d0497c5a]{margin-bottom:5px}.h6[data-v-d0497c5a],address[data-v-d0497c5a]:last-child{margin-bottom:0}.h6[data-v-d0497c5a]{padding-right:20px}.text[data-v-d0497c5a]{margin-top:1em}.text[data-v-d0497c5a]  p:last-child,.text[data-v-d0497c5a]  ul:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
